import {Nav, Navbar} from 'react-bootstrap';
function Footer() {
    return (
        <Navbar bg="dark" data-bs-theme="dark" className='mt-3'>
          <Nav className="me-auto">
            <Nav.Link href="http://www.hmzinfomedia.com">Bayaz-e-Gham Designed and Developed By HMZ Infomedia</Nav.Link>
            </Nav>
      </Navbar>
    );
};
export default Footer;